import { useParams } from 'react-router-dom';

import { AppAssetsSettingsPage } from '~/components/pages/AppAssetsSettingsPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const AppAssetsSettingsRoute: React.FC = () => {
  const { appId } = useParams();

  if (!appId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppAssetsSettingsPage appId={appId} />
    </DashboardTemplate>
  );
};
